import React from 'react';

var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.414 12l6.293-6.293a1 1 0 1 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L9.414 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowLeft.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowLeft as icon };
export default iconHandler(ArrowLeft);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowLeft.js
// module id = 580
// module chunks = 0